import clsx from "clsx";
import { forwardRef, useId } from "react";
import styles from "./index.module.css";

export interface TextFieldProps
  extends Omit<React.ComponentProps<"input">, "size"> {
  label?: string;
  placeholder?: string;
  icon?: React.ReactNode;

  size?: "large" | "medium";
  variant?: "outlined" | "filled";

  classNames?: {
    container?: string;
    input?: string;
  };
  error?: string | null;
}

const sizes = {
  large: "",
  medium: styles.medium
};

const variants = {
  outlined: "",
  filled: styles.filled
};

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  (
    {
      label,
      size,
      placeholder: _,
      classNames,
      className,
      id,
      icon,
      variant,
      error,
      ...inputProps
    },
    ref
  ) => {
    const internalId = useId();
    const resolvedId = id || internalId;

    return (
      <label
        htmlFor={resolvedId}
        className={clsx(
          styles.textField,
          size && sizes[size],
          !!error && styles.error,
          className,
          variant && variants[variant]
        )}
      >
        {label && <span className={styles.labelText}>{error ?? label}</span>}
        <input
          ref={ref}
          id={resolvedId}
          type="text"
          className={clsx(styles.input, classNames?.input)}
          placeholder=" "
          {...inputProps}
        />
        {icon && <span className={styles.icon}>{icon}</span>}
      </label>
    );
  }
);

TextField.displayName = "TextField";
